import React from "react";

export const GridTitle = ({ children }: { children: React.ReactNode }) => (
  <div className="px-5 md:px-10 py-5 bg-Buttons-disabled text-Text-main font-bold text-sm leading-5 text-nowrap">
    {children}
  </div>
);

export const Grid = ({ children }: { children: React.ReactNode }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 text-Text-main">{children}</div>
);

export const GridSection = ({ children }: { children: React.ReactNode }) => (
  <section className="mb-2 md:mb-6">{children}</section>
);

export const GridRow = ({ children }: { children: React.ReactNode }) => (
  <div className="grid grid-cols-2 text-sm leading-5">{children}</div>
);

export const BoldCell = ({ children }: { children: React.ReactNode }) => (
  <p className="font-bold px-5 md:px-10 py-3 md:py-5">{children}</p>
);

export const NormalCell = ({ children }: { children: React.ReactNode }) => (
  <p className="font-normal px-5 md:px-10 py-3 md:py-5">{children}</p>
);

export interface TradeSummaryRowProps {
  label: React.ReactNode;
  value: React.ReactNode;
}

export const TradeSummaryRow = ({ label, value }: TradeSummaryRowProps) => (
  <div className="grid grid-cols-2 md:grid-cols-4 text-sm leading-5">
    <NormalCell>{label}</NormalCell>
    <div className="col-span-1 md:col-span-3 py-3 md:py-5">
      <p className="font-normal text-sm leading-5">{value}</p>
    </div>
  </div>
);

export interface TradeSummaryInlineRowProps {
  label: React.ReactNode;
  value: React.ReactNode;
}

export const TradeSummaryInlineRow = ({ label, value }: TradeSummaryInlineRowProps) => (
  <div className="grid grid-cols-2 md:grid-cols-3 text-sm leading-5 mb-2 last:mb-0">
    <div className="font-normal text-sm leading-5">{label}</div>
    <div className="col-span-1 md:col-span-2">
      <p className="font-normal text-sm leading-5">{value}</p>
    </div>
  </div>
);
